import { render, staticRenderFns } from "./alarm-detail.vue?vue&type=template&id=070f32ec"
import script from "./alarm-detail.vue?vue&type=script&lang=js"
export * from "./alarm-detail.vue?vue&type=script&lang=js"
import style0 from "./alarm-detail.vue?vue&type=style&index=0&id=070f32ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports